<template>
    <div class="bg-white flex-1 relative overflow-y-auto xl:overflow-hidden">
        <loading :status="loading.form"/>
        <div class="flex relative flex-col-reverse xl:flex-row">
            <div :style="{height: 'calc(100vh - 70px)'}" class="flex-auto min-w-0">
                <div class="w-full h:auto border-b sm:border-t xl:border-t-0 sm:px-3">
                    <div class="sm:flex sm:justify-between sm:flex-wrap">
                        <div class="flex sm:flex-grow">
                            <button class="btn p-4 rounded-none" type="button" @click="$router.push('/dashboard/tickets')">
                                <svg-vue class="h-5 w-5 text-gray-700" icon="font-awesome.chevron-left-regular"></svg-vue>
                            </button>
                            <div v-on-clickaway="closeActionDropdown" class="block">
                                <div class="relative inline-block text-left">
                                    <button class="btn p-4 rounded-none" type="button" @click="toggleActionDropdown('agent')">
                                        <svg-vue class="h-5 w-5 text-gray-700" icon="font-awesome.user-tag-regular"></svg-vue>
                                    </button>
                                    <div v-show="actions.agent" class="origin-top-right absolute left-0 mt-1 w-56 rounded-md shadow-lg z-20">
                                        <div class="rounded-md bg-white shadow-xs">
                                            <div class="py-1">
                                                <template v-for="agent in agentList">
                                                    <a
                                                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                        href="#"
                                                        role="menuitem"
                                                        @click.prevent="action('agent', agent.id)"
                                                    >
                                                        {{ agent.name }}
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="relative inline-block text-left">
                                    <button class="btn p-4 rounded-none" type="button" @click="toggleActionDropdown('user')">
                                        <svg-vue class="h-5 w-5 text-gray-700" icon="font-awesome.users-regular"></svg-vue>
                                    </button>
                                    <div v-show="actions.user" class="origin-top-right absolute left-0 mt-1 w-80 rounded-md shadow-lg z-20">
                                        <div class="rounded-md bg-white shadow-xs p-2">
                                            <div class="mt-1 relative rounded-md shadow-sm">
                                                <input-select
                                                    id="user"
                                                    v-model="user"
                                                    :options="userList"
                                                    option-label="name"
                                                    @input="action('user', user)"
                                                    searchable
                                                >
                                                <template v-slot:selectedOption="props">
                                                        <template v-if="props && !props.anySelected">
                                                            <span class="block truncate">{{ $t('Select an option') }}</span>
                                                        </template>
                                                        <template v-else>
                                                            <div class="flex-shrink-0 inline-block">
                                                                <img :src="props.option.avatar" alt="Icon" class="w-5 h-auto rounded-full object-scale-down">
                                                            </div>
                                                            <span class="block truncate">{{ props.option.name }}</span>
                                                        </template>
                                                    </template>
                                                    <template v-slot:selectOption="props">
                                                        <div class="flex items-center space-x-3">
                                                            <div class="flex-shrink-0 inline-block">
                                                                <img :src="props.option.avatar" alt="Icon" class="w-5 h-auto rounded-full object-scale-down">
                                                            </div>
                                                            <div :class="props.option.id === ticket.user_id ? 'font-semibold' : 'font-normal'" class="font-normal block truncate">
                                                                {{ props.option.name }}
                                                            </div>
                                                        </div>
                                                    </template>
                                                </input-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="relative inline-block text-left">
                                    <button class="btn p-4 rounded-none" type="button" @click="toggleActionDropdown('department')">
                                        <svg-vue class="h-5 w-5 text-gray-700" icon="font-awesome.users-class-regular"></svg-vue>
                                    </button>
                                    <div v-show="actions.department" class="origin-top-right absolute left-0 mt-1 w-56 rounded-md shadow-lg z-20">
                                        <div class="rounded-md bg-white shadow-xs">
                                            <div class="py-1">
                                                <template v-for="department in departmentList">
                                                    <a
                                                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                        href="#"
                                                        role="menuitem"
                                                        @click.prevent="action('department', department.id)"
                                                    >
                                                        {{ department.name }}
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="relative inline-block text-left">
                                    <button class="btn p-4 rounded-none" type="button" @click="toggleActionDropdown('label')">
                                        <svg-vue class="h-5 w-5 text-gray-700" icon="font-awesome.tags-regular"></svg-vue>
                                    </button>
                                    <div v-show="actions.label" class="origin-top-right absolute left-0 mt-1 w-56 rounded-md shadow-lg z-20">
                                        <div class="rounded-md bg-white shadow-xs">
                                            <div class="py-1">
                                                <template v-for="label in labelList">
                                                    <a
                                                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                        href="#"
                                                        role="menuitem"
                                                        @click.prevent="action('label', label.id)"
                                                    >
                                                        {{ label.name }}
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="relative inline-block text-left">
                                    <button class="btn p-4 rounded-none" type="button" @click="toggleActionDropdown('priority')">
                                        <svg-vue class="h-5 w-5 text-gray-700" icon="font-awesome.pennant-regular"></svg-vue>
                                    </button>
                                    <div v-show="actions.priority" class="origin-top-right absolute left-0 mt-1 w-56 rounded-md shadow-lg z-20">
                                        <div class="rounded-md bg-white shadow-xs">
                                            <div class="py-1">
                                                <template v-for="priority in priorityList">
                                                    <a
                                                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                                        href="#"
                                                        role="menuitem"
                                                        @click.prevent="action('priority', priority.id)"
                                                    >
                                                        {{ priority.name }}
                                                    </a>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn p-4 rounded-none" type="button" @click="deleteTicketModal = true">
                                <svg-vue class="h-5 w-5 text-gray-700" icon="font-awesome.trash-alt-regular"></svg-vue>
                            </button>
                        </div>
                        <div class="flex items-center justify-end sm:flex-grow m-3 sm:m-2">
                            <div class="text-2xl font-semibold">#{{ ticket.id }}</div>
                            <div v-if="ticket.status" class="px-3">
                                <div class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-blue-100 text-blue-800">
                                    {{ ticket.status.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ticket-conversation overflow-visible xl:overflow-auto">
                    <div class="block">
                        <div class="sm:flex sm:items-center py-3 max-w-full border-b">
                            <div class="px-6 sm:pl-6 sm:pr-3 sm:flex-1 sm:w-1/2">
                                <div class="text-xl truncate">{{ ticket.subject }}</div>
                                <template v-for="(label, index) in ticket.labels">
                                    <div
                                        :style="{backgroundColor: label.color}"
                                        class="inline-flex items-center px-2 py-0.5 mr-1 rounded text-xs font-medium leading-4 text-gray-100"
                                    >
                                        {{ label.name }}
                                        <button class="flex-shrink-0 ml-1.5 inline-flex text-gray-100 focus:outline-none focus:text-gray-100 cursor-pointer" type="button" @click="removeLabel(index)">
                                            <svg-vue class="h-3 w-3" icon="font-awesome.times-solid"></svg-vue>
                                        </button>
                                    </div>
                                </template>
                            </div>
                            <div class="px-6 sm:pl-3 sm:pr-6 sm:flex-1 sm:w-1/2">
                                <div class="flex items-center gap-3 sm:float-right mt-3 sm:mt-0">
                                    <div class="text-sm">
                                        <span class="hidden lg:inline-block text-gray-500">({{ ticket.created_at | momentFormatDateTimeAgo }})</span>
                                        {{ ticket.created_at | momentFormatDateTime }}
                                    </div>
                                    <button class="flex items-center btn btn-white p-2" type="button" @click="showReplyForm()">
                                        <svg-vue class="h-4 w-4 mr-2" icon="font-awesome.reply-regular"></svg-vue>
                                        {{ $t('Reply') }}
                                    </button>
                                    <button class="flex items-center btn btn-white p-2" type="button" @click="showReplyForm(true)">
                                        <svg-vue class="h-4 w-4 mr-2" icon="font-awesome.reply-regular"></svg-vue>
                                        {{ $t('Note') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-show="replyForm" class="px-6 py-3 border-b">
                            <loading :status="loading.reply"/>
                            <form @submit.prevent="addReply">
                                <input-wysiwyg
                                    id="ticket_body"
                                    v-model="ticketReply.body"
                                    :cannedReplyList="cannedReplyList"
                                    :plugins="{images: true, cannedReply: true, attachment: true, shortCode: true}"
                                    @selectUploadFile="selectUploadFile"
                                >
                                    <template v-slot:top>
                                        <div :class="{'bg-gray-200': uploadingFileProgress > 0}" class="h-1 w-full">
                                            <div :style="{width: uploadingFileProgress + '%'}" class="bg-blue-500 py-0.5"></div>
                                        </div>
                                    </template>
                                    <template v-slot:bottom>
                                        <div class="flex justify-between border border-t-0">
                                            <button
                                                class="btn btn-secondary rounded-none"
                                                type="button"
                                                @click="discardReply"
                                            >
                                                {{ $t('Discard') }}
                                            </button>
                                            <div class="flex">
                                                <select
                                                    id="status"
                                                    v-model="ticketReply.status_id"
                                                    aria-label="Sort by"
                                                    class="block form-select pl-3 pr-9 py-2 border-l border-r-0 border-t-0 border-b-0 border-gray-400 rounded-none bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                                                >
                                                    <template v-for="status in statusList">
                                                        <option :value="status.id">{{ status.name }}</option>
                                                    </template>
                                                </select>
                                                <button
                                                    class="btn btn-green rounded-none"
                                                    type="submit"
                                                >
                                                    {{ ticketReply.note ? $t('Send note') : $t('Send reply') }}
                                                </button>
                                            </div>
                                        </div>
                                    </template>
                                </input-wysiwyg>
                            </form>
                            <input ref="fileInput" hidden type="file" @change="uploadFile($event)">
                            <template v-if="ticketReply.attachments.length > 0">
                                <div class="mt-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                                    <template v-for="(attachment, index) in ticketReply.attachments">
                                        <attachment :details="attachment" v-on:remove="removeAttachment(index)"/>
                                    </template>
                                </div>
                            </template>
                        </div>
                        <template v-if="ticket.replies.length > 0">
                            <div class="block">
                                <template v-for="(ticketReply, index) in ticket.replies">
                                    <div :class="{'border-t' : index > 0, 'bg-note' : ticketReply.note}" class="flex p-6">
                                        <img
                                            :alt="$t('Avatar')"
                                            :src="ticketReply.user.avatar"
                                            class="h-12 w-12 hidden sm:inline object-scale-down"
                                        />
                                        <div class="sm:pl-6 pb-2 w-full">
                                            <div class="sm:flex sm:items-center sm:justify-between sm:gap-2 pb-1">
                                                <div class="sm:flex-1">
                                                    <div class="text-lg font-semibold text-gray-800">
                                                        {{ ticketReply.user.name }}
                                                    </div>
                                                    <div class="text-sm">
                                                        {{ ticketReply.created_at | momentFormatDateTime }}
                                                    </div>
                                                </div>
                                                <div v-if="ticketReply.user.id == $store.state.user.id" class="flex items-center gap-2 mt-3 sm:mt-0">
                                                    <button
                                                        class="flex items-center btn btn-white py-1"
                                                        type="button"
                                                        @click="showEditReplyForm(ticketReply.id, ticketReply.body)"
                                                    >
                                                        <svg-vue class="h-4 w-4 mr-2" icon="font-awesome.pen-to-square-regular"></svg-vue>
                                                        {{ $t('Edit') }}
                                                    </button>
                                                    <button
                                                        class="flex items-center btn btn-white py-1"
                                                        type="button"
                                                        @click="deleteReplyModal = true; deleteTicketReply.id = ticketReply.id; deleteTicketReply.note = ticketReply.note"
                                                    >
                                                        <svg-vue class="h-4 w-4 mr-2" icon="font-awesome.trash-alt-regular"></svg-vue>
                                                        {{ $t('Delete') }}
                                                    </button>
                                                </div>
                                            </div>
                                            <div v-show="ticketReply.id == editTicketReply.id && editTicketReply.show">
                                                <loading :status="loading.reply"/>
                                                <form @submit.prevent="editReply">
                                                    <input-wysiwyg
                                                        :id="'ticketReply_' + ticketReply.id + '_body'"
                                                        v-model="editTicketReply.body"
                                                        :cannedReplyList="cannedReplyList"
                                                        :plugins="{images: true, shortCode: true}"
                                                        @selectUploadFile="selectUploadFile"
                                                    >
                                                        <template v-slot:bottom>
                                                            <div class="flex justify-end border border-t-0">
                                                                <button
                                                                    class="btn btn-green rounded-none"
                                                                    type="submit"
                                                                >
                                                                    {{ ticketReply.note ? $t('Edit note') : $t('Edit reply') }}
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </input-wysiwyg>
                                                </form>
                                            </div>
                                            <shadow-root v-show="ticketReply.id != editTicketReply.id || !editTicketReply.show">
                                                <p class="text-gray-700 ticket-reply-body" v-html="ticketReply.body"/>
                                            </shadow-root>
                                            <template v-if="ticketReply.attachments.length > 0">
                                                <div class="mt-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                                                    <template v-for="attachment in ticketReply.attachments">
                                                        <attachment :details="attachment" :remove-button="false"/>
                                                    </template>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <div class="h-full flex border-t">
                                <div class="m-auto">
                                    <div class="grid grid-cols-1 justify-items-center h-full w-full py-24">
                                        <div class="flex justify-center items-center">
                                            <svg-vue class="h-full h-auto w-48 mb-6" icon="undraw.task-list"></svg-vue>
                                        </div>
                                        <div class="flex justify-center items-center">
                                            <div class="w-full font-semibold text-2xl">{{ $t('This ticket has no conversations') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="flex flex-col sm:flex-row xl:flex-col flex-shrink-0 w-full xl:w-72 bg-gray-100 border-l">
                <div class="p-6 flex-auto sm:hidden xl:block xl:flex-none">
                    <div class="text-gray-800 font-medium truncate">{{ $t('Ticket') }}</div>
                    <div class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.clock-solid"></svg-vue>
                        <span class="truncate">{{ ticketDuration | capitalize }}</span>
                    </div>
                    <div v-if="ticket.email" class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.envelope-solid"></svg-vue>
                        <span class="truncate">{{ ticket.email }}</span>
                    </div>
                    <div v-else class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.envelope-solid"></svg-vue>
                        <span class="truncate">{{ $t('No email assigned') }}</span>
                    </div>
                    <div v-if="ticket.phones.length == 0" class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.phone-solid"></svg-vue>
                        <span class="truncate">{{ $t('No phones assigned') }}</span>
                    </div>
                    <div v-else v-for="phone in ticket.phones" class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.phone-solid"></svg-vue>
                        <span class="truncate">{{ phone.country_code == "34" ? phone.number : "+" + phone.country_code + phone.number }}</span>
                    </div>
                </div>
                <hr class="sm:h-auto xl:h-0 sm:border-r xl:border-r-0">
                <div v-if="ticket.agent" class="p-6 flex-auto xl:flex-none">
                    <div class="flex items-center gap-4">
                        <img
                            :alt="$t('Avatar')"
                            :src="ticket.agent.avatar"
                            class="h-16 w-16 object-scale-down"
                        />
                        <div>
                            <div class="text-gray-800 font-medium truncate">{{ $t('Agent') }}</div>
                            <div
                                v-show="ticket.agent.status"
                                class="mt-1 flex items-center text-sm leading-5 text-gray-500"
                            >
                                <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-green-400" icon="font-awesome.check-circle-solid"></svg-vue>
                                {{ $t('Active') }}
                            </div>
                            <div
                                v-show="!ticket.agent.status"
                                class="mt-1 flex items-center text-sm leading-5 text-red-500"
                            >
                                <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-red-400" icon="font-awesome.times-circle-solid"></svg-vue>
                                {{ $t('Deactivated') }}
                            </div>
                        </div>
                    </div>
                    <div class="mt-2">
                        <div class="text-gray-800 font-medium truncate">{{ ticket.agent.name }}</div>
                        <div class="flex items-center mt-2 text-sm leading-5 text-gray-600">
                            <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.envelope-solid"></svg-vue>
                            <span class="truncate">{{ ticket.agent.email ? ticket.agent.email : "-" }}</span>
                        </div>
                        <div v-for="phone in ticket.agent.phones" class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                            <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.phone-solid"></svg-vue>
                            <span class="truncate">{{ phone.country_code == "34" ? phone.number : "+" + phone.country_code + phone.number }}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="p-6 flex-auto xl:flex-none">
                    <div class="text-gray-800 font-medium truncate">{{ $t('Unassigned') }}</div>
                </div>
                <hr class="sm:h-auto xl:h-0 sm:border-r xl:border-r-0">
                <div v-if="ticket.user" class="p-6 flex-auto xl:flex-none">
                    <div class="flex items-center gap-4">
                        <img
                            :alt="$t('Avatar')"
                            :src="ticket.user.avatar"
                            class="h-16 w-16 object-scale-down"
                        />
                        <div>
                            <div class="text-gray-800 font-medium truncate">{{ $t('User') }}</div>
                            <div
                                v-show="ticket.user.status"
                                class="mt-1 flex items-center text-sm leading-5 text-gray-500"
                            >
                                <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-green-400" icon="font-awesome.check-circle-solid"></svg-vue>
                                {{ $t('Active') }}
                            </div>
                            <div
                                v-show="!ticket.user.status"
                                class="mt-1 flex items-center text-sm leading-5 text-red-500"
                            >
                                <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-red-400" icon="font-awesome.times-circle-solid"></svg-vue>
                                {{ $t('Deactivated') }}
                            </div>
                        </div>
                    </div>
                    <div class="mt-2">
                        <div class="text-gray-800 font-medium truncate">{{ ticket.user.name }}</div>
                        <div class="flex items-center mt-2 text-sm leading-5 text-gray-600">
                            <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.envelope-solid"></svg-vue>
                            <span class="truncate">{{ ticket.user.email ? ticket.user.email : "-" }}</span>
                        </div>
                        <div v-for="phone in ticket.user.phones" class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                            <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.phone-solid"></svg-vue>
                            <span class="truncate">{{ phone.country_code == "34" ? phone.number : "+" + phone.country_code + phone.number }}</span>
                        </div>
                        <div v-if="ticket.user.centers.length > 0 ?? false" class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                            <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.building-regular"></svg-vue>
                            <span class="">{{ (ticket.user.centers[0].organization ? ticket.user.centers[0].organization.name : "-") }}</span>
                        </div>
                        <div v-for="center in ticket.user.centers" class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                            <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.hospital-regular"></svg-vue>
                            <span class="truncate">{{ center.name }}</span>
                        </div>
                        <div v-if="ticket.user.profile" class="flex items-center mt-1 text-sm leading-5 text-gray-600">
                            <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4" icon="font-awesome.id-badge-regular"></svg-vue>
                            <span class="">{{ ticket.user.profile.name }}</span>
                        </div>
                    </div>
                </div>
                <div v-else class="p-6 flex-auto xl:flex-none">
                    <div class="text-gray-800 font-medium truncate">{{ $t('Unassigned') }}</div>
                </div>
                <hr>
            </div>
        </div>
        <div v-show="deleteTicketModal" class="fixed z-20 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <transition
                    duration="300"
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <div v-show="deleteTicketModal" class="fixed inset-0 transition-opacity">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>
                </transition>
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
                <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        v-show="deleteTicketModal"
                        aria-labelledby="modal-headline"
                        aria-modal="true"
                        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                        role="dialog"
                    >
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div class="sm:flex sm:items-start">
                                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                    <svg-vue class="h-6 w-6 pb-1 text-red-600" icon="font-awesome.exclamation-triangle-light"></svg-vue>
                                </div>
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <h3 id="modal-headline" class="text-lg leading-6 font-medium text-gray-900">
                                        {{ $t('Delete ticket') }}
                                    </h3>
                                    <div class="mt-2">
                                        <p class="text-sm leading-5 text-gray-500">
                                            {{ $t('Are you sure you want to delete the ticket?') }}
                                            {{ $t('All data will be permanently removed') }}.
                                            {{ $t('All related data will be deleted') }}.
                                            {{ $t('This action cannot be undone') }}.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                            <button
                                class="btn btn-red mr-2 sm:mr-0"
                                type="button"
                                @click="deleteTicket"
                            >
                                {{ $t('Delete ticket') }}
                            </button>
                            <button
                                class="btn btn-white mr-0 sm:mr-2"
                                type="button"
                                @click="deleteTicketModal = false"
                            >
                                {{ $t('Cancel') }}
                            </button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div v-show="deleteReplyModal" class="fixed z-20 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <transition
                    duration="300"
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <div v-show="deleteReplyModal" class="fixed inset-0 transition-opacity">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>
                </transition>
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
                <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        v-show="deleteReplyModal"
                        aria-labelledby="modal-headline"
                        aria-modal="true"
                        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                        role="dialog"
                    >
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div class="sm:flex sm:items-start">
                                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                    <svg-vue class="h-6 w-6 pb-1 text-red-600" icon="font-awesome.exclamation-triangle-light"></svg-vue>
                                </div>
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <h3 id="modal-headline" class="text-lg leading-6 font-medium text-gray-900">
                                        {{ deleteTicketReply.note ? $t('Delete note') : $t('Delete reply') }}
                                    </h3>
                                    <div class="mt-2">
                                        <p class="text-sm leading-5 text-gray-500">
                                            {{ deleteTicketReply.note ? $t('Are you sure you want to delete the note?') : $t('Are you sure you want to delete the reply?') }}
                                            {{ $t('All data will be permanently removed') }}.
                                            {{ $t('All related data will be deleted') }}.
                                            {{ $t('This action cannot be undone') }}.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                            <button
                                class="btn btn-red mr-2 sm:mr-0"
                                type="button"
                                @click="deleteReply"
                            >
                                {{ deleteTicketReply.note ? $t('Delete note') : $t('Delete reply') }}
                            </button>
                            <button
                                class="btn btn-white mr-0 sm:mr-2"
                                type="button"
                                @click="deleteReplyModal = false"
                            >
                                {{ $t('Cancel') }}
                            </button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import {mixin as clickaway} from "vue-clickaway";

export default {
    name: "manage",
    mixins: [clickaway],
    metaInfo() {
        return {
            title: this.$i18n.t('Manage ticket')
        }
    },
    mounted() {
        this.getTicket();
        this.getUsers();
        this.getFilters();
        this.getCannedReplies();
    },
    data() {
        return {
            loading: {
                form: true,
                reply: false,
                file: false,
            },
            deleteTicketModal: false,
            deleteReplyModal: false,
            replyForm: false,
            uploadingFileProgress: 0,
            ticket: {
                subject: null,
                agent: null,
                user: null,
                phones: [],
                created_at: null,
                updated_at: null,
                labels: [],
                replies: [],
                status: null
            },
            ticketReply: {
                status_id: null,
                id_ext: null,
                note: false,
                body: '',
                attachments: [],
            },
            editTicketReply: {
                id: -1,
                id_ext: null,
                body: '',
                attachments: [],
                show: false,
            },
            deleteTicketReply: {
                id: -1,
                note: false,
            },
            actions: {
                agent: false,
                user: false,
                department: false,
                label: false,
                priority: false,
            },
            cannedReplyList: [],
            agentList: [],
            userList: [],
            departmentList: [],
            labelList: [],
            statusList: [],
            priorityList: [],
            user: null,
            asyncLoad: {
                loading: 0,
                entity: 0,
                newUser: 0,
                form: 0,
                file: 0,
                details: 0,
                password: 0,
                reply: 0,
            },
        }
    },
    computed: {
        ticketDuration() {
            if ([3,4].includes(this.ticket?.status?.id)) {
                return moment(this.ticket.created_at).locale(window.app.app_date_locale).to(moment(this.ticket.replies[0]?.created_at ?? this.ticket.created_at), true);
            } else {
                return moment(this.ticket.created_at).locale(window.app.app_date_locale).toNow(true);
            }
        }
    },
    filters: {
        momentFormatDateTime: function (value) {
            return moment(value).locale(window.app.app_date_locale).format(window.app.app_date_format + ' HH:mm');
        },
        momentFormatDateTimeAgo: function (value) {
            return moment(value).locale(window.app.app_date_locale).fromNow();
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    methods: {
        getTicket() {
            const self = this;
            self.asyncLoading("form");
            return axios.get('api/dashboard/tickets/' + self.$route.params.uuid).then(function (response) {
                self.ticket = response.data;
                self.ticketReply.status_id = response.data.status.id;
                self.safeControl();
                self.asyncLoading("form", false);
            }).catch(function () {
                self.$router.push('/dashboard/tickets');
            });
        },
        getUsers() {
            const self = this;
            return axios.get('api/dashboard/admin/users/list', {
                params: {
                    status: true,
                    light: true
                }
            }).then(function (response) {
                self.userList = response.data.users;
                self.user = self.ticket.user.id;
            });
        },
        getCannedReplies() {
            const self = this;
            return axios.get('api/dashboard/tickets/canned-replies').then(function (response) {
                self.cannedReplyList = response.data;
            });
        },
        getFilters() {
            const self = this;
            return axios.get('api/dashboard/tickets/filters').then(function (response) {
                self.agentList = response.data.agents;
                self.departmentList = response.data.departments;
                self.labelList = response.data.labels;
                self.statusList = response.data.statuses;
                self.priorityList = response.data.priorities;
            });
        },
        safeControl() {
            const self = this;
            let replies = self.ticket.replies;
            for (let i = 0; i < replies.length; i++) {
                let html = new DOMParser().parseFromString(replies[i].body, 'text/html');
                html.querySelectorAll("meta").forEach(e => e.remove());
                html.querySelectorAll("script").forEach(e => e.remove());
                self.ticket.replies[i].body = html.body.innerHTML + "";
            }
        },
        discardReply() {
            this.ticketReply.body = '';
            this.ticketReply.attachments = [];
            this.replyForm = false;
        },
        selectUploadFile() {
            if (!this.loading.file) {
                this.$refs.fileInput.click();
            } else {
                this.$notify({
                    title: this.$i18n.t('Error').toString(),
                    text: this.$i18n.t('A file is being uploaded').toString(),
                    type: 'warning'
                });
            }
        },
        uploadFile(e) {
            const self = this;
            const formData = new FormData();
            self.asyncLoading("file");
            formData.append('file', e.target.files[0]);
            axios.post(
                'api/dashboard/tickets/attachments',
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data'},
                    onUploadProgress: function (progressEvent) {
                        self.uploadingFileProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    }.bind(this)
                }
            ).then(function (response) {
                self.asyncLoading("file", false);
                self.uploadingFileProgress = 0;
                self.$refs.fileInput.value = null;
                self.ticketReply.attachments.push(response.data);
            }).catch(function () {
                self.asyncLoading("file", false);
                self.uploadingFileProgress = 0;
                self.$refs.fileInput.value = null;
            });
        },
        removeAttachment(attachment) {
            this.ticketReply.attachments.splice(attachment, 1);
        },
        removeLabel(index) {
            const self = this;
            const label = self.ticket.labels[index];
            axios.post('api/dashboard/tickets/' + self.$route.params.uuid + '/remove-label', {
                label: label.id,
            }).then(function () {
                self.ticket.labels.splice(index, 1);
            });
        },
        addReply() {
            const self = this;
            self.asyncLoading("reply");
            axios.post('api/dashboard/tickets/' + self.$route.params.uuid + '/reply', self.ticketReply).then(function (response) {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.ticket = response.data.ticket;
                self.ticketReply.status_id = response.data.ticket.status_id;
                self.discardReply();
                self.asyncLoading("reply", false);
            }).catch(function () {
                self.asyncLoading("reply", false);
            });
        },
        editReply() {
            const self = this;
            self.asyncLoading("form");
            axios.post('api/dashboard/tickets/' + self.$route.params.uuid + '/edit-reply', self.editTicketReply).then(function (response) {
                self.ticket = response.data.ticket;
                self.ticketReply.status_id = response.data.ticket.status_id;
                self.showEditReplyForm(-1);
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.asyncLoading("form", false);
            }).catch(function () {
                self.asyncLoading("form", false);
            });
        },
        deleteReply() {
            const self = this;
            self.asyncLoading("form");
            axios.delete('api/dashboard/tickets/' + self.$route.params.uuid + '/delete-reply', {
                params: {
                    id: self.deleteTicketReply.id
                }
            }).then(function (response) {
                self.ticket = response.data.ticket;
                self.ticketReply.status_id = response.data.ticket.status_id;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data deleted successfully').toString(),
                    type: 'success'
                });
                self.deleteReplyModal = false;
                self.asyncLoading("form", false);
            }).catch(function () {
                self.asyncLoading("form", false);
            });
        },
        closeActionDropdown() {
            this.actions.agent = false;
            this.actions.user = false;
            this.actions.department = false;
            this.actions.label = false;
            this.actions.priority = false;
        },
        toggleActionDropdown(action) {
            if (action === 'agent') {
                this.actions.agent = !this.actions.agent;
                this.actions.user = false;
                this.actions.department = false;
                this.actions.label = false;
                this.actions.priority = false;
            }
            if (action === 'user') {
                this.actions.user = !this.actions.user;
                this.actions.agent = false;
                this.actions.department = false;
                this.actions.label = false;
                this.actions.priority = false;
            }
            if (action === 'department') {
                this.actions.department = !this.actions.department;
                this.actions.agent = false;
                this.actions.user = false;
                this.actions.label = false;
                this.actions.priority = false;
            }
            if (action === 'label') {
                this.actions.label = !this.actions.label;
                this.actions.agent = false;
                this.actions.user = false;
                this.actions.department = false;
                this.actions.priority = false;
            }
            if (action === 'priority') {
                this.actions.priority = !this.actions.priority;
                this.actions.agent = false;
                this.actions.user = false;
                this.actions.department = false;
                this.actions.label = false;
            }
        },
        action(param, value) {
            const self = this;
            self.asyncLoading("form");
            axios.post('api/dashboard/tickets/' + self.$route.params.uuid + '/quick-actions', {
                action: param,
                value: value,
            }).then(function (response) {
                self.closeActionDropdown();
                if (!response.data.access) {
                    self.$router.push('/dashboard/tickets');
                } else {
                    self.ticket = response.data.ticket;
                    self.ticketReply.status_id = response.data.ticket.status_id;
                }
                self.asyncLoading("form", false);
            }).catch(function () {
                self.closeActionDropdown();
                self.asyncLoading("form", false);
            });
        },
        deleteTicket() {
            const self = this;
            axios.delete('api/dashboard/tickets/' + self.$route.params.uuid).then(function () {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data deleted successfully').toString(),
                    type: 'success'
                });
                self.$router.push('/dashboard/tickets');
            }).catch(function () {
                self.deleteTicketModal = false;
            });
        },
        showReplyForm(note = false) {
            const self = this;
            if (self.replyForm && self.ticketReply.note != note) {
                self.ticketReply.note = note;
            } else {
                self.replyForm = !self.replyForm;
                self.ticketReply.note = note;
            }
        },
        showEditReplyForm(id = -1, body = "") {
            const self = this;
            if (self.editTicketReply.id == id) {
                self.editTicketReply.show = !self.editTicketReply.show;
            } else {
                self.editTicketReply.show = true;
            }
            self.editTicketReply.id = id;
            self.editTicketReply.body = body;
        },
        asyncLoading(types = "", mode = true) {
            const self = this;
            types = types.split(',');
            for (let i = 0; i < types.length; i++) {
                if (mode) {
                    switch (types[i]) {
                        case "entity":
                            self.asyncLoad.entity++;
                            if (self.asyncLoad.entity == 1) {
                                self.loading.entity = true;
                            }
                            break;
                        case "newUser":
                            self.asyncLoad.newUser++;
                            if (self.asyncLoad.newUser == 1) {
                                self.loading.newUser = true;
                            }
                            break;
                        case "form":
                            self.asyncLoad.form++;
                            if (self.asyncLoad.form == 1) {
                                self.loading.form = true;
                            }
                            break;
                        case "file":
                            self.asyncLoad.file++;
                            if (self.asyncLoad.file == 1) {
                                self.loading.file = true;
                            }
                            break;
                        case "details":
                            self.asyncLoad.details++;
                            if (self.asyncLoad.details == 1) {
                                self.loading.details = true;
                            }
                            break;
                        case "password":
                            self.asyncLoad.password++;
                            if (self.asyncLoad.password == 1) {
                                self.loading.password = true;
                            }
                            break;
                        case "reply":
                            self.asyncLoad.reply++;
                            if (self.asyncLoad.reply == 1) {
                                self.loading.reply = true;
                            }
                            break;
                        default:
                            self.asyncLoad.loading++;
                            if (self.asyncLoad.loading == 1) {
                                self.loading = true;
                            }
                            break;
                    }
                } else {
                    switch (types[i]) {
                        case "entity":
                            self.asyncLoad.entity--;
                            if (self.asyncLoad.entity <= 0) {
                                self.asyncLoad.entity = 0;
                                self.loading.entity = false;
                            }
                            break;
                        case "newUser":
                            self.asyncLoad.newUser--;
                            if (self.asyncLoad.newUser <= 0) {
                                self.asyncLoad.newUser = 0;
                                self.loading.newUser = false;
                            }
                            break;
                        case "form":
                            self.asyncLoad.form--;
                            if (self.asyncLoad.form <= 0) {
                                self.asyncLoad.form = 0;
                                self.loading.form = false;
                            }
                            break;
                        case "file":
                            self.asyncLoad.file--;
                            if (self.asyncLoad.file <= 0) {
                                self.asyncLoad.file = 0;
                                self.loading.file = false;
                            }
                            break;
                        case "details":
                            self.asyncLoad.details--;
                            if (self.asyncLoad.details <= 0) {
                                self.asyncLoad.details = 0;
                                self.loading.details = false;
                            }
                            break;
                        case "password":
                            self.asyncLoad.password--;
                            if (self.asyncLoad.password <= 0) {
                                self.asyncLoad.password = 0;
                                self.loading.password = false;
                            }
                            break;
                        case "reply":
                            self.asyncLoad.reply--;
                            if (self.asyncLoad.reply <= 0) {
                                self.asyncLoad.reply = 0;
                                self.loading.reply = false;
                            }
                            break;
                        default:
                            self.asyncLoad.loading--;
                            if (self.asyncLoad.loading <= 0) {
                                self.asyncLoad.loading = 0;
                                self.loading = false;
                            }
                            break;
                    }
                }
            }
        }
    }
}
</script>
<style lang="css">
.bg-note {
    background-color: #feffc7;
}
.sidebar-fixed {
    flex: '0 0 260px';
    width: '260px';
}
</style>